const CYBERSOURCE = 'cybersource';
const CLEARSALE = 'clearsale';

export const setupFingerprint = ({ type, data }) => {
    switch(type){
        case CYBERSOURCE:
            const script = document.createElement('script');
            script.src = data.url;
            document.body.appendChild(script);

            break;
        case CLEARSALE:
            // Reference: https://api.clearsale.com.br/docs/behavior-analytics/sdk/browser
            (function (a, b, c, d, e, f, g) {
            a['CsdpObject'] = e; a[e] = a[e] || function () {
            (a[e].q = a[e].q || []).push(arguments)
            }, a[e].l = 1 * new Date(); f = b.createElement(c),
            g = b.getElementsByTagName(c)[0]; f.async = 1; f.src = d; g.parentNode.insertBefore(f, g)
            })(window, document, 'script', '//device.clearsale.com.br/p/fp.js', 'csdp');
            csdp('app', data.app);
            csdp('sessionid', data.sessionid);

            break;
    }
};
